import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { NATIVE_BOTTOM_BAR_SPACING } from "web_myplann/Shared/constants";

export const useBottomBarSpacing = () =>
	useGoalsRightOptional() ? NATIVE_BOTTOM_BAR_SPACING : undefined;
